import React from "react";
import { ImPointRight } from "react-icons/im";

function AboutCard({ currentTheme }) {
  return (
    <div
      style={{
        background:
          currentTheme === "dark"
            ? "rgba(30,34,54,0.85)"
            : "rgba(220,230,255,0.85)",
        borderRadius: 24,
        boxShadow:
          currentTheme === "dark"
            ? "0 8px 32px 0 rgba(30,34,54,0.25)"
            : "0 8px 32px 0 rgba(80,120,200,0.15)",
        padding: "2.5rem 2rem",
        margin: "0 auto 2rem auto",
        maxWidth: 650,
        border: "1.5px solid rgba(120,140,200,0.13)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 24,
      }}
    >
      <h2
        style={{
          fontWeight: 800,
          fontSize: "2.2em",
          marginBottom: 0,
          color: currentTheme === "dark" ? "#a5b4fc" : "#2563eb",
          letterSpacing: "-1px",
          textAlign: "center",
        }}
      >
        About <span className="purple">Me</span>
      </h2>
      <div
        style={{
          fontSize: "1.18em",
          color: "#64748b",
          fontWeight: 600,
          textAlign: "center",
          marginBottom: 8,
        }}
      >
        Hi, I am <span className="purple">Meet Jain</span> from{" "}
        <span className="purple">Bhopal (MP), India</span>.<br />
        B.Tech (2022–2026), IIIT Jabalpur.
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 18,
        }}
      >
        <div
          style={{
            background:
              currentTheme === "dark"
                ? "rgba(59,130,246,0.10)"
                : "rgba(59,130,246,0.08)",
            borderRadius: 16,
            padding: "1.1em 1.3em",
            display: "flex",
            alignItems: "center",
            gap: 18,
            boxShadow: "0 2px 12px 0 rgba(59,130,246,0.08)",
          }}
        >
          <ImPointRight
            style={{ color: "#2563eb", fontSize: 28, flexShrink: 0 }}
          />
          <span
            style={{
              fontSize: "1.08em",
              color: currentTheme === "dark" ? "#e0e7ff" : "#1e293b",
            }}
          >
            Open to diverse tech roles across{" "}
            <b className="purple">Software development</b>,{" "}
            <b className="purple">AI</b>, <b className="purple">web</b>, and{" "}
            <b className="purple">blockchain</b> domains.
          </span>
        </div>
        <div
          style={{
            background:
              currentTheme === "dark"
                ? "rgba(59,130,246,0.10)"
                : "rgba(59,130,246,0.08)",
            borderRadius: 16,
            padding: "1.1em 1.3em",
            display: "flex",
            alignItems: "center",
            gap: 18,
            boxShadow: "0 2px 12px 0 rgba(59,130,246,0.08)",
          }}
        >
          <ImPointRight
            style={{ color: "#2563eb", fontSize: 28, flexShrink: 0 }}
          />
          <span
            style={{
              fontSize: "1.08em",
              color: currentTheme === "dark" ? "#e0e7ff" : "#1e293b",
            }}
          >
            Flexible with work setups – <b className="purple">remote</b>,{" "}
            <b className="purple">onsite</b>,{" "}
            <b className="purple">full-time</b>,{" "}
            <b className="purple">part-time</b>,{" "}
            <b className="purple">freelance</b>,{" "}
            <b className="purple">contract-based</b>, or{" "}
            <b className="purple">bounty-driven</b> roles.
          </span>
        </div>
        <div
          style={{
            background:
              currentTheme === "dark"
                ? "rgba(59,130,246,0.10)"
                : "rgba(59,130,246,0.08)",
            borderRadius: 16,
            padding: "1.1em 1.3em",
            display: "flex",
            alignItems: "center",
            gap: 18,
            boxShadow: "0 2px 12px 0 rgba(59,130,246,0.08)",
          }}
        >
          <ImPointRight
            style={{ color: "#2563eb", fontSize: 28, flexShrink: 0 }}
          />
          <span
            style={{
              fontSize: "1.08em",
              color: currentTheme === "dark" ? "#e0e7ff" : "#1e293b",
            }}
          >
            Comfortable working across{" "}
            <b className="purple">global time zones</b> with adaptable hours.
          </span>
        </div>
        <div
          style={{
            background:
              currentTheme === "dark"
                ? "rgba(59,130,246,0.10)"
                : "rgba(59,130,246,0.08)",
            borderRadius: 16,
            padding: "1.1em 1.3em",
            display: "flex",
            alignItems: "center",
            gap: 18,
            boxShadow: "0 2px 12px 0 rgba(59,130,246,0.08)",
          }}
        >
          <ImPointRight
            style={{ color: "#2563eb", fontSize: 28, flexShrink: 0 }}
          />
          <span
            style={{
              fontSize: "1.08em",
              color: currentTheme === "dark" ? "#e0e7ff" : "#1e293b",
            }}
          >
            Always ready to contribute to{" "}
            <b className="purple">meaningful projects</b> that drive impact and
            continuous learning.
          </span>
        </div>
      </div>
    </div>
  );
}

export default AboutCard;
